module.exports = __webpack_public_path__ + "files/6f095bbc9c135f3825f67d3a5a05c400.png";